<template>
  <div>
    <ui-modal
      ref="modal"
      @close="ActionSetVisibleModalEditar(false)"
      :title="`Actualizar Sección - ${titulo}`"
      size="large"
    >
      <div class="d-flex">
        <ui-textbox
          floating-label
          label="Nombre"
          v-model="formulario.nombreModel"
          class="w-50 mr-3"
        />
        <ui-textbox
          floating-label
          label="Referencia"
          v-model="formulario.referenciaModel"
          class="w-50"
        />
      </div>
      <!-- row 1 -->
      <div class="d-flex">
        <ui-select
          class="w-100"
          has-search
          label="Módulo"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ value: 'id', label: 'name' }"
          :options="listaModulos"
          v-model="formulario.moduloModel"
        />
      </div>
      <!-- Footer -->
      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-outline-secondary" @click="closeModal('modal')">
          Cerrar
        </button>
        <button class="btn btn-outline-primary" @click="actualizarSeccion">
          Guardar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";
import UiSelect from "keen-ui/src/UiSelect";

// Constantes
import {
  updateSeccion,
  getSecciones,
} from "../../../../constants/superadministrador";

export default {
  props: ["data", "listaSecciones", "listaModulos"],
  data() {
    return {
      formulario: {
        id: "",
        nombreModel: "",
        referenciaModel: "",
        moduloModel: [],
      },
      titulo: "",
      dataAux: this.data,
    };
  },

  components: {
    UiModal,
    UiTextbox,
    UiSelect,
  },

  computed: {
    ...mapState(["visibleModalEditar"]),
  },

  methods: {
    ...mapActions("superadministrador", ["actionSetDataSecciones"]),
    ...mapActions(["ActionSetVisibleModalEditar"]),

    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },

    async actualizarSeccion() {
      let sql = await updateSeccion(this.formulario);

      if (!sql.error) {
        // Toast proceso exitoso
        this.$vToastify.success("Sección actualizada con éxito", "¡Realizado!");

        // Limpiar variables
        this.formulario.nombreModel = "";
        this.formulario.referenciaModel = "";
        this.formulario.moduloModel = "";

        let dataSeccionesDB = await getSecciones();
        this.dataAux = dataSeccionesDB;

        this.actionSetDataSecciones(dataSeccionesDB.data_table);

        // Cerrar Modal
        this.closeModal("modal");
      } else {
        if (sql.data.length > 0) {
          // Errores de validación
          sql.data.map((item) => {
            this.$vToastify.error(`${item}`);
          });
        } else {
          // Proceso erroneo
          this.$vToastify.error(
            "La Sección no ha podido actualizarse",
            "¡Error!"
          );
        }
      }
    },
  },

  watch: {
    visibleModalEditar: function (_new) {
      _new && this.openModal("modal");
    },
    data: function (_new) {
      this.titulo = _new.data[0];

      // Formulario
      this.formulario.id = _new.data_complementaria.id_seccion;
      this.formulario.nombreModel = _new.data[0];
      this.formulario.referenciaModel = _new.data[1];
      this.formulario.moduloModel = _new.data[2];
    },
  },
};
</script>
